/**
 * Tema Test Sayfası
 * Bu sayfa Rasket temasından alınan bootstrap bileşenlerini test etmek için kullanılır
 */
import React from 'react';
import { Card, Row, Col, Button, Form, ProgressBar } from 'react-bootstrap';

const TemaTest: React.FC = () => {
  return (
    <div className="content-wrapper">
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1>Rasket Tema Test</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item"><a href="/">Ana Sayfa</a></li>
                <li className="breadcrumb-item active">Tema Test</li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          {/* Kartlar */}
          <h4 className="mb-3">Kartlar</h4>
          <Row>
            <Col md={4}>
              <Card className="card-dashboard">
                <Card.Header>
                  <Card.Title>Standart Kart</Card.Title>
                </Card.Header>
                <Card.Body>
                  <p>Bu bir standart karttır. Rasket temasından alınmıştır.</p>
                  <Button variant="primary">Tamam</Button>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="card-border card-border-success">
                <Card.Header>
                  <Card.Title>Kenarlıklı Kart</Card.Title>
                </Card.Header>
                <Card.Body>
                  <p>Bu bir kenarlıklı karttır. Üst tarafında yeşil çizgi vardır.</p>
                  <Button variant="success">Tamam</Button>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="card-header-bg-primary">
                <Card.Header>
                  <Card.Title>Renkli Başlık</Card.Title>
                </Card.Header>
                <Card.Body>
                  <p>Bu kartın başlığı mavi renklidir.</p>
                  <Button variant="outline-primary">Tamam</Button>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Butonlar */}
          <h4 className="mt-4 mb-3">Butonlar</h4>
          <Card>
            <Card.Body>
              <h5>Renk Varyantları</h5>
              <div className="mb-3">
                <Button variant="primary" className="me-2">Primary</Button>
                <Button variant="secondary" className="me-2">Secondary</Button>
                <Button variant="success" className="me-2">Success</Button>
                <Button variant="info" className="me-2">Info</Button>
                <Button variant="warning" className="me-2">Warning</Button>
                <Button variant="danger" className="me-2">Danger</Button>
              </div>
              
              <h5>Outline Butonlar</h5>
              <div className="mb-3">
                <Button variant="outline-primary" className="me-2">Primary</Button>
                <Button variant="outline-secondary" className="me-2">Secondary</Button>
                <Button variant="outline-success" className="me-2">Success</Button>
                <Button variant="outline-danger" className="me-2">Danger</Button>
              </div>
              
              <h5>Boyutlar</h5>
              <div className="mb-3">
                <Button variant="primary" size="sm" className="me-2">Küçük</Button>
                <Button variant="primary" className="me-2">Normal</Button>
                <Button variant="primary" size="lg" className="me-2">Büyük</Button>
              </div>
              
              <h5>Özel Butonlar</h5>
              <div>
                <Button variant="primary" className="btn-rounded me-2">Yuvarlak</Button>
                <Button variant="success" className="btn-icon me-2">
                  <i className="fas fa-check"></i> İkon ile
                </Button>
                <Button variant="info" className="btn-icon-circle me-2">
                  <i className="fas fa-plus"></i>
                </Button>
                <Button variant="soft-warning" className="me-2">Soft Warning</Button>
              </div>
            </Card.Body>
          </Card>

          {/* Formlar */}
          <h4 className="mt-4 mb-3">Form Elemanları</h4>
          <Row>
            <Col md={6}>
              <Card>
                <Card.Body>
                  <h5>Temel Form Elemanları</h5>
                  <Form>
                    <Form.Group className="mb-3">
                      <Form.Label>Email adresi</Form.Label>
                      <Form.Control type="email" placeholder="name@example.com" />
                      <Form.Text className="text-muted">
                        Email adresinizi asla paylaşmayacağız.
                      </Form.Text>
                    </Form.Group>
                    
                    <Form.Group className="mb-3">
                      <Form.Label>Şifre</Form.Label>
                      <Form.Control type="password" placeholder="Şifre" />
                    </Form.Group>
                    
                    <Form.Group className="mb-3">
                      <Form.Label>Seçim kutusu</Form.Label>
                      <Form.Select>
                        <option>Seçenek 1</option>
                        <option>Seçenek 2</option>
                        <option>Seçenek 3</option>
                      </Form.Select>
                    </Form.Group>
                    
                    <Form.Group className="mb-3">
                      <Form.Check type="checkbox" label="Beni hatırla" />
                    </Form.Group>
                    
                    <Button variant="primary" type="submit">Gönder</Button>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6}>
              <Card>
                <Card.Body>
                  <h5>Form Doğrulama</h5>
                  <Form>
                    <Form.Group className="mb-3">
                      <Form.Label>İsim</Form.Label>
                      <Form.Control 
                        type="text" 
                        placeholder="İsminizi girin" 
                        className="is-valid" 
                      />
                      <Form.Control.Feedback>Görünüşe göre iyi!</Form.Control.Feedback>
                    </Form.Group>
                    
                    <Form.Group className="mb-3">
                      <Form.Label>Kullanıcı Adı</Form.Label>
                      <Form.Control 
                        type="text" 
                        placeholder="Kullanıcı adı girin" 
                        className="is-invalid"
                      />
                      <Form.Control.Feedback type="invalid">
                        Lütfen bir kullanıcı adı seçin.
                      </Form.Control.Feedback>
                    </Form.Group>
                    
                    <Form.Group className="mb-3">
                      <Form.Label>Arama</Form.Label>
                      <div className="search-box">
                        <Form.Control type="text" placeholder="Ara..." />
                        <div className="search-icon">
                          <i className="fas fa-search"></i>
                        </div>
                      </div>
                    </Form.Group>
                    
                    <Form.Group className="mb-3">
                      <Form.Label>Onay Kutusu</Form.Label>
                      <Form.Switch id="custom-switch" label="Aktif/Pasif" />
                    </Form.Group>
                    
                    <Button variant="success" type="submit">Kaydet</Button>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          
          {/* İlerleme Çubukları */}
          <h4 className="mt-4 mb-3">İlerleme Çubukları</h4>
          <Card>
            <Card.Body>
              <h5>Basit İlerleme Çubuğu</h5>
              <ProgressBar now={60} label={`%60`} className="mb-3" />
              
              <h5>Renkli İlerleme Çubukları</h5>
              <ProgressBar variant="success" now={40} className="mb-2" />
              <ProgressBar variant="info" now={20} className="mb-2" />
              <ProgressBar variant="warning" now={60} className="mb-2" />
              <ProgressBar variant="danger" now={80} className="mb-3" />
              
              <h5>Adım Göstergeleri</h5>
              <Row className="text-center">
                <Col md={4} className="step active">
                  <div className="step-circle">1</div>
                  <div className="step-title">Adım 1</div>
                </Col>
                <Col md={4} className="step">
                  <div className="step-circle">2</div>
                  <div className="step-title">Adım 2</div>
                </Col>
                <Col md={4} className="step">
                  <div className="step-circle">3</div>
                  <div className="step-title">Adım 3</div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
          
          {/* Yardımcı Sınıflar */}
          <h4 className="mt-4 mb-3">Yardımcı Sınıflar</h4>
          <Row>
            <Col md={6}>
              <Card>
                <Card.Body>
                  <h5>Yazı Boyutları ve Kalınlıkları</h5>
                  <p className="fs-12">Bu yazı 12px boyutundadır</p>
                  <p className="fs-14">Bu yazı 14px boyutundadır</p>
                  <p className="fs-16">Bu yazı 16px boyutundadır</p>
                  <p className="fw-medium">Bu yazı orta kalınlıktadır</p>
                  <p className="fw-semibold">Bu yazı yarı kalındır</p>
                  <p className="fw-bold">Bu yazı kalındır</p>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6}>
              <Card>
                <Card.Body>
                  <h5>Diğer Yardımcılar</h5>
                  <div className="p-3 mb-2 bg-light rounded">Bu bir arkaplan rengine sahip</div>
                  <p className="text-primary">Bu birincil renkte yazıdır</p>
                  <p className="opacity-75">Bu %75 opaklığa sahiptir</p>
                  <p className="cursor-pointer">Bu yazı üzerine gelince el imleci gösterir</p>
                  <p className="text-truncate-2">Bu çok uzun bir metindir ve iki satıra sığdırılarak kesilir. 
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse quis justo eget nisi
                    tincidunt euismod. Duis luctus tortor in mauris malesuada facilisis.</p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      </section>
    </div>
  );
};

export default TemaTest;